<script setup lang="ts">
defineProps<{
  class?: string
}>()
</script>

<template>
  <!--
    Skylark bird mark — displayed as a square image.
    Source: apps/web/src/assets/images/logo-mark.jpg
    TODO: Replace with SVG export for crisp rendering at all sizes.
  -->
  <img
    src="@/assets/images/logo-mark.jpg"
    alt="Skylark AV"
    :class="$props.class"
    draggable="false"
  />
</template>
